import { apiGet } from 'api/service';
import { getAccessToken } from 'api/authTokens';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL || '';

// Scilla-style multi-format output.
export const RECON_EXPORT_FORMATS = [
  { id: 'txt', label: 'Plain text' },
  { id: 'json', label: 'JSON' },
  { id: 'csv', label: 'CSV' },
  { id: 'html', label: 'HTML report' }
];

export function getReconExportFormats() {
  return apiGet('/api/recon-export/formats/');
}

/**
 * Download recon results in `fmt`.
 *
 * The endpoint returns a file, not JSON, so this can't go through apiGet.
 * A plain <a href> would not work either: the API authenticates with a Bearer
 * token rather than a cookie, so the request must be made with fetch and the
 * response turned into a blob download.
 *
 * NOTE: the query parameter is `fmt`, not `format` — DRF reserves `format`
 * for content negotiation and would 404 before the view runs.
 */
export async function downloadReconExport(userTargetId, fmt = 'txt', scanId = null) {
  const params = new URLSearchParams({ fmt });
  if (scanId) params.set('scan', scanId);
  else params.set('user_target', userTargetId);

  const token = getAccessToken();
  const res = await fetch(`${API_BASE_URL}/api/recon-export/?${params.toString()}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });

  if (!res.ok) {
    let detail = `Export failed (${res.status})`;
    try {
      const body = await res.json();
      detail = body.detail || detail;
    } catch {
      /* non-JSON error body */
    }
    throw new Error(detail);
  }

  // Prefer the filename the server chose.
  const disposition = res.headers.get('content-disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `recon.${fmt}`;

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return filename;
}
